/**
 * @method getInitials
 * @param {Array.<string>} names the full names
 * @returns {String} the initials string
 */
const getInitials = (names) => {
  if (!Array.isArray(names)) {
    return '';
  }

  const initials = names.reduce((acc, name) => {
    if (typeof name === 'string') {
      const firstLetter = name.substring(0, 1);
      acc = acc.concat(firstLetter);
    }

    return acc;
  }, '');

  return initials;
};

export default getInitials;
